import React from 'react';

interface IndicatorDotsProps {
  count?: number; // Total de puntos (por defecto 3)
  activeIndex?: number; // Índice del punto activo (por defecto 0)
  size?: number; // Tamaño en px de cada punto (por defecto 8)
  activeColor?: string; // Clase Tailwind para el punto activo
  inactiveColor?: string; // Clase Tailwind para los puntos inactivos
}

const IndicatorDots: React.FC<IndicatorDotsProps> = ({
  count = 3,
  activeIndex = 2,
  size = 5,
  activeColor = 'bg-white',
  inactiveColor = 'bg-gray-200/25',
}) => {
  const dots = Array.from({ length: count }, (_, i) => i);

  return (
    <div className="flex items-center space-x-2">
      {dots.map((i) => {
        const isActive = i === activeIndex;
        const width = isActive ? size * 16 : size * 5;
        return (
          <span
            key={i}
            className={`rounded-[24px] ${isActive ? activeColor : inactiveColor}`}
            style={{
              width: `${width}px`,
              height: `${size}px`,
              transition: 'background-color 0.3s ease',
            }}
          />
        );
      })}
    </div>
  );
};

export default IndicatorDots;
